/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>azure-ad-auth-logout.component.ts</name>
///
/// <description>
/// A class that handles the authenticated user's login
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>12 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 12Aug16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Component, ElementRef, Renderer} from '@angular/core';
import { HydrogenAppConfigService } from '../../../host.config.service'
import {hydUtilService} from "../../../utils/hydUtils.service";
import {CUIFeatureInterface} from  '../../../interfaces/cui-feature.interface';
import {HydUser} from '../../../models/user';
import {TranslatedStringsService } from '../../../services/language.service';

@Component({
    templateUrl: './azure-ad-auth-logout.component.html'    
})


export class AzureADAuthLogoutComponent implements CUIFeatureInterface  {
    private config: any;
    private lblLoggingOut: string;

    constructor(
        private configSvc: HydrogenAppConfigService,
        private hydUser: HydUser,
        private i18n: TranslatedStringsService,
        private elementRef: ElementRef,
        private renderer: Renderer
    ) 
    {
        console.log('AzureADAuthLogoutComponent constructor '+window.location);
    }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
    ngOnChanges(changes: any) {   };
    //ngOnInit(){  };
    ngDoCheck() {   };
    ngAfterContentInit() {   };
    ngAfterContentChecked() {  };
    ngAfterViewInit() {   };
    ngAfterViewChecked() {  };
    ngOnDestroy() {   };

    public ngOnInit() {


        let container = this.elementRef.nativeElement.parentElement.parentElement;
        if (container) {
            this.renderer.setElementStyle(container, 'background-color', '#343A3E');

        }


        this.lblLoggingOut = this.i18n.translate("logging-out");
        this.config = this.configSvc.config;
        this.Logout(null);



    }

    private Logout(event) {
        this.hydUser.logout();

        if (event)
            event.preventDefault();
        let endpoint =
            this.config.azureAD.SecureTokenServer + this.config.azureAD.Tenant + this.config.azureAD.OAuth2Logout +
            "?post_logout_redirect_uri=" + this.GetRedirectUrl()
            ;
        console.debug(hydUtilService.TimeStamp()+"Redirecting to Azure AD");
        window.location.href = endpoint;
    }

    private GetRedirectUrl() {
        return window.location.protocol + "//" + window.location.host;
    }

}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/azure-active-directory/azure-ad-auth-logout/azure-ad-auth-logout.component.ts